import { Alert, Button, Grid, TextField, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";

import axios from "axios";
import { blackHex, btnStyleText, lightergrayHex, subHeaderStyle, textfieldStyle, textSmallStyle, textStyle } from "./helper/style";
import logoToko from "./assets/liqueLogo.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from 'dayjs';

const btnSubmit = {
  marginTop: "20px",
  justifyContent: "center",
  borderRadius: "50px",
  backgroundColor: "white",
  color: "black",
  width: "100%",
  maxWidth: "100%"
};

function ForgotPage() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState();
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validate = () => {
    let tempErrors = {};
    
    if (!email) {
      tempErrors.email = "Email is required";
    } else if (email.length > 255) {
      tempErrors.email = "Email can be at most 255 characters";
    } else if (!emailRegex.test(email)) {
      tempErrors.email = "Invalid email format";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const formData = new FormData();
      formData.append("email", email);
      const response = await axios.post(
        `${backendUrl}/forgotPassword/request`,
        formData
      );
      setEmail("");

      setMsgSuccess(response.data);
      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        navigate("/login");
      }, 3000);
    } catch (error) {
      console.error("error fetching data: ", error);
      setShowError(true);
      setMsgError(error.response.data);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    }
  };

  return (
    <>
      <Container component="main" maxWidth="md" sx={{ marginY: "50px", minHeight: "80vh" }}>
        {showError && (
          <Alert variant="filled" severity="error" sx={{ marginBottom: 5 }}>
            {msgError}
          </Alert>
        )}
        {showSuccess && (
          <Alert variant="filled" severity="success" sx={{ marginBottom: 5 }}>
            {msgSuccess}
          </Alert>
        )}
        <Box>
          <Grid container spacing={1} marginTop={1} columnSpacing={2}>
            <Grid item xs={12} display="flex" alignItems="center">
              <Box sx={{ background: blackHex, borderRadius: "24px", padding: "50px 30px", width: "100%" }}>
                <Box>
                  <Button sx={{ ...btnStyleText, color: lightergrayHex }} onClick={() => navigate("/login")}>
                    <ArrowBackIcon /> Back to Login
                  </Button>
                </Box>
                <Box marginTop={1}>
                  <img src={logoToko} alt="logo lique" style={{ width: "150px" }} />
                </Box>
                <Box marginBottom={3}>
                  <Typography sx={{ ...subHeaderStyle, fontWeight: "bold" }}>Reset Password</Typography>
                </Box>
                <Box>
                  <Box>
                    <Typography sx={{ ...textStyle }}>Email</Typography>
                    <TextField
                      sx={textfieldStyle}
                      className="input"
                      placeholder="Email"
                      autoComplete="off"
                      fullWidth
                      onChange={(e) => setEmail(e.target.value)}
                      helperText={errors.email}
                      FormHelperTextProps={{ sx: { color: "red" } }}
                    />
                  </Box>
                  <Box marginTop={1}>
                    <Typography sx={{ ...textSmallStyle }}>
                      Please enter your email address, you will receive a link to reset your password.
                    </Typography>
                  </Box>
                </Box>
                <Box textAlign="center">
                  <Button style={{...btnSubmit}} onKeyDown={handleSubmit} onClick={handleSubmit}>
                    Confirm
                  </Button>
                </Box>
                <Box marginTop={3}>
                  <Typography sx={{ ...textSmallStyle, color: lightergrayHex }}>
                    © LIQUE STORE {dayjs().year()}. All RIght Reserved.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default ForgotPage;
